<div class="enterprise-kyb-report">
  <PageControl
    :title="'Enterprise KYB Verification Report'"
    :elements_query="sheet_elements"
  >
    <button
      class="btn btn-bg-green text-xs rounded-small shadow-sm me-2"
      @click="show_export_modal"
    >
      <i class="fas fa-download me-1"></i> Export Data
    </button>

    <!-- Export Modal -->
    <Teleport to="body">
      <div
        class="modal fade"
        :id="'export-modal-' + report_reference"
        tabindex="-1"
        aria-labelledby="exportModalLabel"
        aria-hidden="true"
      >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content rounded-4 shadow">
          <div class="modal-header">
            <h6 class="modal-title fw-semibold text-muted">
              Export Enterprise KYB Verification Data
            </h6>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label fw-bold">Select Data to Export:</label>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="export_options.company_information"
                  id="companyInformation"
                />
                <label class="form-check-label" for="companyInformation">
                  Company Information
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="export_options.statutory_details"
                  id="statutoryDetails"
                />
                <label class="form-check-label" for="statutoryDetails">
                  Statutory Details
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="export_options.principal_details"
                  id="principalDetails"
                />
                <label class="form-check-label" for="principalDetails">
                  Principal Details
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="export_options.verification_summary"
                  id="verificationSummary"
                />
                <label class="form-check-label" for="verificationSummary">
                  Verification Summary
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="export_options.transaction_details"
                  id="transactionDetails"
                />
                <label class="form-check-label" for="transactionDetails">
                  Transaction Details
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="export_options.raw_json"
                  id="rawJson"
                />
                <label class="form-check-label" for="rawJson">
                  Raw JSON Data
                </label>
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label fw-bold">Export Format:</label>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="exportFormat"
                  id="csvFormat"
                  value="csv"
                  v-model="export_format"
                />
                <label class="form-check-label" for="csvFormat">CSV</label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="exportFormat"
                  id="excelFormat"
                  value="excel"
                  v-model="export_format"
                />
                <label class="form-check-label" for="excelFormat">Excel</label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="exportFormat"
                  id="jsonFormat"
                  value="json"
                  v-model="export_format"
                />
                <label class="form-check-label" for="jsonFormat">JSON</label>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-bg-secondary text-xs rounded-small shadow-sm me-2"
              @click="close_modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-bg-green text-xs rounded-small shadow-sm"
              @click="export_data"
              :disabled="!has_selected_tables"
            >
              <i class="fas fa-download me-1"></i>
              Export Data
            </button>
          </div>
        </div>
      </div>
    </div>
    </Teleport>
  </PageControl>

  <PageComponent>

    <SectionSheet>
      <div
        class="container-fluid py-2 header d-flex align-items-center justify-content-between border-bottom mb-2"
      >
        <div class="d-flex">
          <img
            class="logo"
            width="295"
            height="125"
            src="@/assets/images/new_black_logo2.svg"
            alt="Logo"
          />
        </div>
        <div class="d-flex text-end">
          <div>
            <div class="h5 fw-bold mb-1">Enterprise KYB Verification Report</div>
            <div class="text-muted text-xs">
              28 Fricker Rd,<br />
              Illovo, Johannesburg,<br />
              2196 South Africa<br />
              Website:
              <a
                href="https://www.goodpeopledata.com/"
                target="_blank"
                class="text-decoration-none text-muted"
                >www.goodpeopledata.com</a
              >
            </div>
          </div>
        </div>
      </div>

      <!-- Report Summary -->
      <div class="row mb-3">
        <div class="col-12">
          <div class="card shadow-sm border bg-white">
            <div class="card-header">
              <h6 class="mb-0">
                <i class="fas fa-building me-2"></i>Verification Summary
              </h6>
            </div>
            <div class="card-body text-xs">
              <div class="row g-2">
                <div class="col-sm-6">
                  <strong class="text-muted small">Company Name:</strong>
                  <div class="fw-bold">{{ company_name }}</div>
                </div>
                <div class="col-sm-6">
                  <strong class="text-muted small">Registration Number:</strong>
                  <div class="fw-bold">{{ registration_number }}</div>
                </div>
                <div class="col-sm-6">
                  <strong class="text-muted small">Verification Date:</strong>
                  <div class="fw-bold">{{ formatted_verification_date }}</div>
                </div>
                <div class="col-sm-6">
                  <strong class="text-muted small">Verification Status:</strong>
                  <div class="fw-bold" :class="verification_status_badge_class">
                    <i :class="verification_status_icon" class="me-1"></i>
                    {{ overall_verification_status }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Company Information -->
      <div class="card shadow-sm border bg-white mb-3">
        <div class="card-header">
          <h6 class="mb-0">
            <i class="fas fa-info-circle me-2"></i>Company Information
          </h6>
        </div>
        <div class="card-body text-xs">
          <div class="info-grid">
            <div class="info-item">
              <span class="label">Company Name</span>
              <span class="value">{{ company_name }}</span>
            </div>
            <div class="info-item">
              <span class="label">Registration Number</span>
              <span class="value">{{ registration_number }}</span>
            </div>
            <div class="info-item">
              <span class="label">Company Status</span>
              <span class="value">{{ company_status }}</span>
            </div>
            <div class="info-item">
              <span class="label">Registration Date</span>
              <span class="value">{{ registration_date }}</span>
            </div>
            <div class="info-item">
              <span class="label">Business Type</span>
              <span class="value">{{ business_type }}</span>
            </div>
            <div class="info-item">
              <span class="label">Industry Classification</span>
              <span class="value">{{ industry_classification }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Report Footer -->
      <div class="report-meta">
        <div class="text-muted small">
          Report Reference: {{ report_reference }}
        </div>
        <div class="text-muted small">
          Generated: {{ formatted_current_date }}
        </div>
      </div>
    </SectionSheet>

    <SectionSheet>
      <!-- Statutory Details Section -->
      <div class="row mb-4" v-if="statutory_details && statutory_details.length > 0">
        <div class="col-12">
          <div class="card shadow-sm">
            <div class="card-header">
              <h6 class="mb-0">
                <i class="fas fa-file-contract me-2"></i>
                Statutory Details
              </h6>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-sm table-hover">
                  <thead class="table-light">
                    <tr>
                      <th class="text-xs">Type</th>
                      <th class="text-xs">Name</th>
                      <th class="text-xs">ID Number</th>
                      <th class="text-xs">Status</th>
                      <th class="text-xs">Verification</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(detail, index) in statutory_details" :key="index">
                      <td class="text-xs fw-semibold">{{ detail.type }}</td>
                      <td class="text-xs">{{ detail.name }}</td>
                      <td class="text-xs">{{ detail.id_number }}</td>
                      <td class="text-xs">{{ detail.status }}</td>
                      <td class="text-xs">
                        <span :class="get_verification_badge_class(detail.verification_status)" class="badge">
                          {{ detail.verification_status }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Principal Details Section -->
      <div class="row mb-4" v-if="principal_details && principal_details.length > 0">
        <div class="col-12">
          <div class="card shadow-sm">
            <div class="card-header">
              <h6 class="mb-0">
                <i class="fas fa-users me-2"></i>
                Principal Details
              </h6>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-sm table-hover">
                  <thead class="table-light">
                    <tr>
                      <th class="text-xs">Name</th>
                      <th class="text-xs">ID Number</th>
                      <th class="text-xs">Position</th>
                      <th class="text-xs">Email</th>
                      <th class="text-xs">Phone</th>
                      <th class="text-xs">Verification Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(principal, index) in principal_details" :key="index">
                      <td class="text-xs">{{ principal.name }}</td>
                      <td class="text-xs">{{ principal.id_number }}</td>
                      <td class="text-xs">{{ principal.position }}</td>
                      <td class="text-xs">{{ principal.email }}</td>
                      <td class="text-xs">{{ principal.phone }}</td>
                      <td class="text-xs">
                        <span :class="get_verification_badge_class(principal.overall_status)" class="badge">
                          {{ principal.overall_status }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Report Footer -->
      <div class="report-meta">
        <div class="text-muted small">
          Report Reference: {{ report_reference }}
        </div>
        <div class="text-muted small">
          Generated: {{ formatted_current_date }}
        </div>
      </div>
    </SectionSheet>

    <SectionSheet>
      <!-- Verification Results -->
      <div class="row mb-4">
        <div class="col-12">
          <div class="card shadow-sm">
            <div class="card-header">
              <h6 class="mb-0">
                <i class="fas fa-check-circle me-2"></i>
                Verification Results
              </h6>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-sm table-hover">
                  <thead class="table-light">
                    <tr>
                      <th class="text-xs">Verification Check</th>
                      <th class="text-xs">Description</th>
                      <th class="text-xs">Result</th>
                      <th class="text-xs">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="fw-semibold text-xs">Company Registration</td>
                      <td class="text-xs">Verify if company is registered with CIPC</td>
                      <td class="text-xs">{{ company_registration_found }}</td>
                      <td class="text-xs">
                        <span
                          :class="get_verification_badge_class(company_registration_found)"
                          class="badge"
                        >
                          <i
                            :class="get_verification_icon(company_registration_found)"
                            class="me-1"
                          ></i>
                          {{ get_verification_status_text(company_registration_found) }}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td class="fw-semibold text-xs">Registration Number Match</td>
                      <td class="text-xs">Verify if registration number matches records</td>
                      <td class="text-xs">{{ registration_number_match }}</td>
                      <td class="text-xs">
                        <span
                          :class="get_verification_badge_class(registration_number_match)"
                          class="badge"
                        >
                          <i
                            :class="get_verification_icon(registration_number_match)"
                            class="me-1"
                          ></i>
                          {{ get_verification_status_text(registration_number_match) }}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td class="fw-semibold text-xs">Company Name Match</td>
                      <td class="text-xs">Verify if company name matches records</td>
                      <td class="text-xs">{{ company_name_match }}</td>
                      <td class="text-xs">
                        <span
                          :class="get_verification_badge_class(company_name_match)"
                          class="badge"
                        >
                          <i
                            :class="get_verification_icon(company_name_match)"
                            class="me-1"
                          ></i>
                          {{ get_verification_status_text(company_name_match) }}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td class="fw-semibold text-xs">Company Active Status</td>
                      <td class="text-xs">Verify if company is currently active</td>
                      <td class="text-xs">{{ company_active_status }}</td>
                      <td class="text-xs">
                        <span
                          :class="get_verification_badge_class(company_active_status)"
                          class="badge"
                        >
                          <i
                            :class="get_verification_icon(company_active_status)"
                            class="me-1"
                          ></i>
                          {{ get_verification_status_text(company_active_status) }}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td class="fw-semibold text-xs">Principal Information Available</td>
                      <td class="text-xs">Verify if principal information is available</td>
                      <td class="text-xs">{{ principal_information_available }}</td>
                      <td class="text-xs">
                        <span
                          :class="get_verification_badge_class(principal_information_available)"
                          class="badge"
                        >
                          <i
                            :class="get_verification_icon(principal_information_available)"
                            class="me-1"
                          ></i>
                          {{ get_verification_status_text(principal_information_available) }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Report Footer -->
      <div class="report-meta">
        <div class="text-muted small">
          Report Reference: {{ report_reference }}
        </div>
        <div class="text-muted small">
          Generated: {{ formatted_current_date }}
        </div>
      </div>
    </SectionSheet>

    <SectionSheet>
      <div class="card shadow-sm">
        <div class="card-header">
          <h6 class="mb-0">
            <i class="fas fa-exclamation-triangle me-2"></i>
            Disclaimer
          </h6>
        </div>
        <div class="card-body">
          <div class="disclaimer-content">
            <h6 class="mb-3 border-bottom pb-2">
              <i class="bi bi-info-circle me-2"></i>General Information
            </h6>
            <p class="text-xs mb-4">
              This Enterprise KYB Verification Report is prepared solely for the benefit
              of the enquiring party and may not be used for any other purpose without
              the express written consent of The Good People Data Company. The
              information contained in this report is based on data from official
              sources and is provided as is.
            </p>
            <h6 class="mb-3 border-bottom pb-2">
              <i class="bi bi-shield-exclamation me-2"></i>Limitations
            </h6>
            <p class="text-xs mb-4">
              The verification results are based on the information available at the
              time of the enquiry. Company details may change after the verification
              date. This report should be used in conjunction with other due diligence
              procedures for complete business verification.
            </p>
            <h6 class="mb-3 border-bottom pb-2">
              <i class="bi bi-shield-lock me-2"></i>Data Privacy
            </h6>
            <p class="text-xs mb-4">
              All company information is processed in accordance with applicable data
              protection laws including POPIA (Protection of Personal Information Act).
              This report should only be shared with authorized personnel who require
              access to this information for legitimate business purposes.
            </p>
            <div class="text-center text-muted mt-3">
              <p class="mb-0 text-xs">
                © {{ new Date().getFullYear() }} The Good People Data Company.
                All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Report Footer -->
      <div class="report-meta">
        <div class="text-muted small">
          Report Reference: {{ report_reference }}
        </div>
        <div class="text-muted small">
          Generated: {{ formatted_current_date }}
        </div>
      </div>
    </SectionSheet>
  </PageComponent>
</div>
